import 'dayjs/locale/pt-br';

import { formatDate, formatDateInEN, formatInReal } from '../../commons/util/HallAppUtil';
import { useEffect, useState } from 'react';

import AppCard from '../../commons/cards/AppCard';
import AppLinkButton from '../../commons/buttons/AppLinkButton';
import AppLoading from '../../commons/AppLoading';
import HallAppToast from '../../commons/HallAppToast';
import MultiDateFilterInput from '../../commons/inputs/MultiDateFilterInput';
import StockAPI from './StockAPI';
import { useNavigate } from 'react-router-dom';

const stockAPI = new StockAPI

function StockCommissionEmployee() {
    const [isLoading, setIsLoading] = useState(true);
    const [commissions, setCommissions] = useState([]);


    const navigate = useNavigate();

    const endDate = new Date();
    const startDate = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

    const [filter, setFilter] = useState({
        startDate: formatDateInEN(startDate),
        endDate: formatDateInEN(endDate),
    });

    useEffect(() => {
        callGetCommission()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter]);

    const callGetCommission = async () => {
        try {
            setIsLoading(true)
            const resp = await stockAPI.getCommissionEmployee(filter);
            setCommissions(resp.data)
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoading(false)
        }
    }

   
    function changeDates(startDate, endDate) {
        if (endDate === null) {
            endDate = startDate;
        }
        setFilter({
            ...filter,
            startDate: startDate,
            endDate: endDate
        })
    }

    return (
        <div className='container'>
            <div
                style={{
                    position: 'fixed',
                    top: 60,
                    left: 0,
                    right: 0,
                    zIndex: 9999,
                    marginTop: '0',
                    paddingTop: '0',
                    display: 'block',
                    backgroundColor: 'white',
                }}
                className="filter-my-command"
            >
                <MultiDateFilterInput startDate={startDate} endDate={endDate} changeDates={changeDates} />
            </div>
            {isLoading ? <AppLoading /> :
                commissions.map((data) => {
                    return <AppCard key={data.employeeId}>
                        <div className="d-flex justify-content-between align-items-center">
                            <h5 className="card-title mb-0">{data.employeeName}</h5>
                        </div>

                        <p className="card-text mb-1">
                            <strong>Valor total ({formatDate(filter?.startDate)}) á ({formatDate(filter?.endDate)}): </strong> {formatInReal(data?.totalCommission || 0)}
                        </p>

                        <p className="card-text mb-1">
                            <strong>Valor pendente: (verificar em detalhes) </strong> {formatInReal(data?.totalCommissionPending || 0)}
                        </p>

                    
                        <AppLinkButton onClick={() =>  navigate(`/estoque/detalhes/profissional/${data.employeeId}`)} width='100%' name='detalhes' />


                    </AppCard>
                })
            }

        </div>
    );
}

export default StockCommissionEmployee;
